import { useQuery } from "react-query";
import PrivateApi from "../../../services/PrivateApiService";
import { FormControl, ListGroup, ListGroupItem, Modal, Spinner } from "react-bootstrap";
import { FaRegUserCircle } from "react-icons/fa";
import { HiOutlineSwitchVertical } from "react-icons/hi";
import { useEffect, useState } from "react";
import { useAuthDispatch, useAuthState } from "../../../context/AuthContext";

const ContactPersonDrop = ({ isModal }) => {

    const API = new PrivateApi(); // API 
    const { contactPerson } = useAuthState(); // state from auth
    const dispatch = useAuthDispatch();
    const [contacts, setContacts] = useState([]);
    const [showModal, setShowModal] = useState(false);

    // get contact persons
    const { data, isLoading } = useQuery("GET_EMPLOYEES", API.get_Partner_employees, { staleTime: Infinity });

    useEffect(() => {
        if (data && data.data && data.data.length > 0) {
            setContacts(data.data);
        }
    }, [data])

    const handleSearch = (search) => {
        setContacts(data.data.filter(c => c.name.toLowerCase().includes(search.toLowerCase()) ))
    }

    const removeContactPerson = (e) => {
        e.preventDefault();
        dispatch("CLEAR_CONTACT");       
    }   

    if (isLoading) return <Spinner animation="border" />

    if (isModal) return (
        <>
            <button
                style={{ border: "1px solid white", color: "white" }}
                className="btn"
                type="button"
                onClick={() => setShowModal(true)}
            >
                <FaRegUserCircle style={{ marginRight: 5 }} />
                {contactPerson ? contactPerson.name : "Kontaktperson"}
                <HiOutlineSwitchVertical style={{ marginLeft: 5 }} />
            </button>
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Kontaktperson auswählen</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    { contactPerson !== undefined && contactPerson !== null &&
                        <p>
                            <a 
                                onClick={e => removeContactPerson(e)}
                                href="/löschen" className="link-energo">
                                {contactPerson?.name}
                            </a>
                        </p>
                    }

                    <ListGroup>
                        {data && data.data && data.data.length > 0 &&
                            <>
                                <ListGroupItem>
                                    <FormControl placeholder="Suchen" onChange={e => handleSearch(e.target.value)} />
                                </ListGroupItem>
                                {contacts.map(contact => (
                                    <ListGroupItem
                                        key={contact.id} 
                                        onClick={() => {dispatch('POPULATE_CONTACT', {id: contact.id, name: contact.name, email: contact.email}); setShowModal(false)}}>
                                        <FaRegUserCircle className="text-energo" style={{ marginRight: 5 }} />
                                        {contact.name}
                                    </ListGroupItem>
                                ))}
                            </>
                        }
                    </ListGroup>
                </Modal.Body>
            </Modal>
        </>
    )

    return (
        <div className={`contactPersonDrop dropdown ${isModal && "in-menu"}`}>
            <button
                className="btn"
                type="button"
                id="contactPersonMenuBtn"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                <FaRegUserCircle style={{ marginRight: 5 }} />
                {contactPerson ? contactPerson.name : "Kontaktperson"}
                <HiOutlineSwitchVertical style={{ marginLeft: 5 }} />
            </button>
            <ul
                className="dropdown-menu"
                aria-labelledby="contactPersonMenuBtn"

            >
                {data && data.data && data.data.length > 0 &&
                    <>
                        {contactPerson && contactPerson !== null &&
                            <li className="text-center" key="deleteContact">
                                <a href="/löschen" className="link-energo" onClick={e => removeContactPerson(e)}>
                                    {contactPerson.name}
                                </a>
                            </li>
                        }
                        <li style={{padding: 2}}><FormControl placeholder="Suchen" onChange={e => handleSearch(e.target.value)} /></li>

                        {contacts.map(contact => (
                            <li 
                                key={contact.id}
                                onClick={() => dispatch('POPULATE_CONTACT', {id: contact.id, name: contact.name, email: contact.email})}
                                className="dropdown-item" style={{ cursor: "pointer" }}>
                                <FaRegUserCircle className="text-energo" style={{ marginRight: 5 }} />
                                {contact.name}
                            </li>
                        ))}
                    </>
                }
            </ul>
        </div>
    )
}
export default ContactPersonDrop;